module.exports = __webpack_public_path__ + "img/folder.33d42e2d.svg";